import { createContext, useCallback, useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { lockBodyScroll, unlockBodyScroll } from '@/helpers/scroll';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [modals, setModals] = useState([]);
  const location = useLocation();

  useEffect(() => {
    modals.length ? lockBodyScroll() : unlockBodyScroll();
  }, [modals]);

  useLayoutEffect(() => {
    closeAllModals();
  }, [location?.pathname]);

  const openModal = useCallback(modalId => setModals(prev => [...prev, modalId]), []);

  const openSingleModal = useCallback(modalId => setModals([modalId]), []);

  const closeModal = useCallback(modalId =>
    setModals(prev => prev.filter(el => el !== modalId)), []);

  const closeAllModals = useCallback(() => setModals([]), []);

  const modalIds = modals.reduce((acc, id) => {
    acc[id] = id;
    return acc;
  }, {});

  return (
    <ModalContext.Provider
      value={{
        data,
        setData,
        modalIds,
        openModal,
        openSingleModal,
        closeModal,
        closeAllModals,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
